module.exports = __webpack_public_path__ + "static/img/live-banner.cc56cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/live-banner.png
// module id = PZrh
// module chunks = 1